<p-card>
  <ng-template pTemplate="header">
    <div class="title-visualizacao"><span class="cl-blue">Nome: </span>
      <span> {{orgaoJulgadorLocal.nome}}</span>
    </div>
  </ng-template>
  <div class="p-fluid">
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id:</label>
      <div class="p-col-12 p-md-10">{{orgaoJulgadorLocal.id}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Origem:</label>
      <div class="p-col-12 p-md-10">{{orgaoJulgadorLocal.fonteDados.nome}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id Origem:</label>
      <div class="p-col-12 p-md-10">{{orgaoJulgadorLocal.origemId}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Nome:</label>
      <div class="p-col-12 p-md-10">{{orgaoJulgadorLocal.nome}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Órgão Julgador:</label>
      <div class="p-col-12 p-md-10">{{orgaoJulgadorLocal.orgaoJulgador.nome}} -
        <span style="font-size: 0.8em; font-style: italic">{{orgaoJulgadorLocal.orgaoJulgador.orgaoJustica.sigla}}</span>
      </div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Pendente de revalidação:</label>
      <div class="p-col-12 p-md-10">{{ orgaoJulgadorLocal.pendenteRevalidacao | dominio: 'getBooleanoSimNaoItens'}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Situação:</label>
      <div class="p-col-12 p-md-10">
        <span [ngClass]="orgaoJulgadorLocal?.situacao === 'ATIVO' ? 'badge badge-success' : 'badge badge badge-gray'">
        {{ orgaoJulgadorLocal.situacao| dominio: 'getSituacaoItens'}}
        </span>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="p-col-12">
      <button pButton appBotaoVoltar class="p-button-primary  p-lg-12" label="Voltar"></button>
    </div>
  </ng-template>
</p-card>
